//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import D049JS from "../../../../../Media/Image/018.jpg";

//Element
class A14F86 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB v725gm", href: "/az/layiheler" },
            //Element
            React.createElement(Row, {},
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB n02a9p" },
                        //Element
                        React.createElement("img", { alt: "Otel", title: "Otel", src: D049JS, width: "306", height: "auto" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("div", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB z3630j" },
                        //Element
                        React.createElement("h4", { className: "S6pt64 C96Q4r pEO064 a527eB u50e58" },
                            //Element
                            "Otel"
                        ),
                        //Element
                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q8913p" },
                            //Element
                            "2"
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default A14F86;